import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '爆料问答', href: '#faq' },
  { label: '平台简介', href: '#about' },
  { label: 'APP下载', href: '#app' },
  { label: '投稿爆料', href: '#contact' },
  { label: '瓜友热评', href: '#comments' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 h-[72px] flex items-center transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-xl border-b border-background-300/30'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-xl md:text-2xl font-heading font-black text-foreground-50 tracking-tight">
            五一吃瓜网<span className="text-accent-500">🔥</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm font-medium text-foreground-300 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#ranking"
          className="hidden md:inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-accent-500 text-background-950 font-bold text-sm hover:bg-accent-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          每日鲜瓜
          <i className="ri-arrow-right-line"></i>
        </a>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-50 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden absolute top-[72px] left-0 right-0 bg-background-50/95 backdrop-blur-xl border-b border-background-300/30 py-4 px-6 flex flex-col gap-3">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="text-sm font-medium text-foreground-300 hover:text-accent-500 transition-colors duration-200 py-2"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#ranking"
            onClick={() => setMobileOpen(false)}
            className="inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-full bg-accent-500 text-background-950 font-bold text-sm mt-2"
          >
            每日鲜瓜
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      )}
    </header>
  );
}